import React from 'react'
import styled from 'styled-components'
import { colors, device, layout, media } from '../../theme'
import { Tab } from '@fluentui/react-components'
import ButtonGroup from '../../controls/ButtonGroup'

export const PreviewWrapper = styled.div`
  background-color: var(--body-background);
  // display: flex;
  ${media.up(device.tablet)`
    flex-grow: 1;
    order: 1;
    min-height: 250px;
    max-height: 100%;
    overflow: auto;
  `}
`

export const PopupWrapper = styled.div`
  display: flex;
  flex-direction: column;

  overflow: hidden;
`
export const PopupBody = styled.div`
  flex: 1;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
    height: 100%;
  min-height: 360px;

  ${media.down(device.tablet)`
    display: flex;
  `}
`
export const ConfigWrapper = styled.div`
  position: relative;
  position: relative;
  display: flex;
  flex-direction: column;
`
export const CustomTab = styled(Tab)`
  span {
    color: var(--text) !important;
  }
`

export const OneDriveWrapper = styled.div`
  color: var(--text);
  margin: 24px 0;
  .formRow {
    margin: 10px 0;
  }
`

export const CustomButtonGrp = styled(ButtonGroup)`
  label {
    cursor: pointer;
  }
`
